// extracted by mini-css-extract-plugin
export var blockImage = "S_cJ";
export var imageContainer = "S_bH";